import { render, staticRenderFns } from "./SupportPackages.vue?vue&type=template&id=5df23a6b&scoped=true"
import script from "./SupportPackages.vue?vue&type=script&lang=js"
export * from "./SupportPackages.vue?vue&type=script&lang=js"
import style0 from "./SupportPackages.vue?vue&type=style&index=0&id=5df23a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df23a6b",
  null
  
)

export default component.exports